"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "routes", {
    enumerable: true,
    get: function() {
        return routes;
    }
});
const _types = require("./types");
const routes = (0, _types.buildRoutes)({
    repetitiveLosses: {
        path: "/repetitive-losses"
    },
    repetitiveLossesImports: {
        path: "/settings/data/repetitive-loss"
    },
    geocodeRepetitiveLoss: {
        path: "/repetitive-loss/:id/geocode"
    }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvcmVwZXRpdGl2ZUxvc3Nlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIHJlcGV0aXRpdmVMb3NzZXM6IHtcbiAgICBwYXRoOiBcIi9yZXBldGl0aXZlLWxvc3Nlc1wiLFxuICB9LFxuICByZXBldGl0aXZlTG9zc2VzSW1wb3J0czoge1xuICAgIHBhdGg6IFwiL3NldHRpbmdzL2RhdGEvcmVwZXRpdGl2ZS1sb3NzXCIsXG4gIH0sXG4gIGdlb2NvZGVSZXBldGl0aXZlTG9zczoge1xuICAgIHBhdGg6IFwiL3JlcGV0aXRpdmUtbG9zcy86aWQvZ2VvY29kZVwiLFxuICB9LFxufSk7XG4iXSwibmFtZXMiOlsicm91dGVzIiwiYnVpbGRSb3V0ZXMiLCJyZXBldGl0aXZlTG9zc2VzIiwicGF0aCIsInJlcGV0aXRpdmVMb3NzZXNJbXBvcnRzIiwiZ2VvY29kZVJlcGV0aXRpdmVMb3NzIl0sIm1hcHBpbmdzIjoiOzs7OytCQUVhQTs7O2VBQUFBOzs7dUJBRmU7QUFFckIsTUFBTUEsU0FBU0MsSUFBQUEsa0JBQVcsRUFBQztJQUNoQ0Msa0JBQWtCO1FBQ2hCQyxNQUFNO0lBQ1I7SUFDQUMseUJBQXlCO1FBQ3ZCRCxNQUFNO0lBQ1I7SUFDQUUsdUJBQXVCO1FBQ3JCRixNQUFNO0lBQ1I7QUFDRiJ9